export const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

export function formatValue(value, format) {
  switch (format) {
    case 'currency':
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      }).format(Number(value || 0))
    case 'percentage':
      return `${Number(value || 0)}%`
    case 'decimal':
      return Number(value || 0).toFixed(1)
    default:
      return new Intl.NumberFormat('pt-BR').format(Number(value || 0))
  }
}

